"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ErrorBase = _interopRequireDefault(require("./_ErrorBase"));
var _excluded = ["description", "headerText"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CustomError = function CustomError(_ref) {
  var description = _ref.description,
    headerText = _ref.headerText,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_ErrorBase.default, _extends({}, props, {
    customDescription: description,
    customHeader: headerText
  }));
};
CustomError.propTypes = {
  headerText: _propTypes.default.string.isRequired,
  backUrl: _propTypes.default.string,
  className: _propTypes.default.string,
  correlationId: _propTypes.default.string,
  description: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })),
  paragraphs: _propTypes.default.arrayOf(_propTypes.default.shape({
    className: _propTypes.default.string,
    text: _propTypes.default.string
  }))
};
var _default = exports.default = CustomError;